import React, { Component } from "react";
import { connect } from "react-redux";
import { isCurrentUserSuperAdmin } from "../utils/userRoles";
import { TextLabel } from "../components/TextLabel";

export class OrganizationName extends Component {
  render() {
    const { organizations, organizationRef } = this.props;
    return (
      <div>
        {isCurrentUserSuperAdmin() && (
          <TextLabel label="Organization" value={ organizations[organizationRef.id].name} />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  organizations: state.data.organizations
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationName);
